export enum AC_ENUM {
  ACTIVITY = "Activity",
}

export const AC_FILTER_KEYS = [
  "dateRange",
  "entity",
  "action",
  "search",
  "limit",
  "offset",
  "currentPage",
  "sortBy",
  "orderBy",
];

export const ACTIVITY_ENTITY = [
  {
    label: "Invoice",
    id: "INVOICE",
  },
  {
    label: "Work Docket",
    id: "WORK_DOCKET",
  },
  {
    label: "Estimates",
    id: "ESTIMATES",
  },
  {
    label: "Warehouse Item",
    id: "WAREHOUSE_ITEM",
  },
  {
    label: "Workspace",
    id: "WORKSPACE",
  },
  {
    label: "Project",
    id: "PROJECT",
  },
  {
    label: "Leads",
    id: "LEADS",
  },
  {
    label: "Item",
    id: "ITEM",
  },
  {
    label: "Item Group",
    id: "ITEM_GROUP",
  },
  {
    label: "Claims",
    id: "CLAIMS",
  },
  {
    label: "Customer",
    id: "CUSTOMER",
  },
  {
    label: "Prospect",
    id: "PROSPECT",
  },
  {
    label: "Workforce",
    id: "WORKFORCE",
  },
  {
    label: "Day Report",
    id: "DAY_REPORT",
  },
  {
    label: "Payroll",
    id: "PAYROLL",
  },
  {
    label: "Timesheet",
    id: "TIMESHEET",
  },
  {
    label: "Waste Management",
    id: "WASTE_MANAGEMENT",
  },
];

export const ACTIVITY_ACTION = [
  {
    label: "Create",
    id: "CREATE",
  },
  {
    label: "Update",
    id: "UPDATE",
  },
  {
    label: "Set Revision",
    id: "SET_REVISION",
  },
  {
    label: "Set Final",
    id: "SET_FINAL",
  },
  {
    label: "Set Not Final",
    id: "SET_NOT_FINAL",
  },
  {
    label: "Status Changed",
    id: "STATUS_CHANGED",
  },
  {
    label: "Delete",
    id: "DELETE",
  },
  {
    label: "Synced",
    id: "SYNCED",
  },
  {
    label: "Moved",
    id: "MOVED",
  },
  {
    label: "Verified",
    id: "VERIFIED",
  },
];
